<template>
  <div class="columns">
    <div class="column is-12">
      <v-card>
        <v-card-title style="padding-bottom:40px;font-size: 28px">Event Tags</v-card-title>
        <v-card-text>
          <v-btn @click="showAddTag">Add Tag</v-btn>
          <br/><br/>
          <v-data-table :items-per-page=5 loading-text="Loading" :items="eventTags" :headers="headers">
            <template
                v-slot:item.actions="{ item }"
            >
              <i class="fa-bold far fa-edit" @click="showEditTag(item)"/>&nbsp;&nbsp;
              <i class="fa-bold far fa-trash" @click="showDeleteTag(item.id)"/>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
    <v-dialog v-model="addingTag">
      <v-card>
        <v-card-title>Add Tag</v-card-title>
        <v-card-text>
          <v-label>Tag Name</v-label>
          <v-text-field v-model="newTag" outlined/>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="addTag" color="primary">Add Event Tag</v-btn>
          <v-btn @click="addingTag = false;">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editingTag">
      <v-card>
        <v-card-title>Edit Event Tag?</v-card-title>
        <v-card-text>
          Tag Name:
          <v-text-field v-model="editTagName" outlined/>
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" @click="editTagId = null; editTagName = null; editingTag = false;">Cancel</v-btn>
          <v-btn color="primary" @click="editTag()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deletingTag">
      <v-card>
        <v-card-title>Delete Tag?</v-card-title>
        <v-card-text>Are you sure you want to delete this tag?</v-card-text>
        <v-card-actions>
          <v-btn color="secondary" @click="this.deleteTagId = null; this.deletingTag = false;">Cancel</v-btn>
          <v-btn color="primary" @click="deleteTag()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<style scoped>
i {
  cursor: pointer;
}
</style>
<script>
import axios from 'axios'

export default {
  name: 'ToolsEditEventTags',
  props: ['token', 'user', 'loginUser'],
  data() {
    return {
      addingTag: false,
      newTag: null,
      editingTag: false,
      eventTags: [],
      editTagId: null,
      deleteTagId: null,
      editTagName: null,
      deletingTag: false,
      headers: [{
        text: 'Tag Name',
        align: 'start',
        sortable: true,
        value: 'name',
      }, {
        text: 'Actions',
        align: 'start',
        sortable: true,
        value: 'actions',
      }]
    }
  },
  mounted: function () {
    this.getTags()
  },
  methods: {
    showAddTag() {
      this.newTag = null;
      this.addingTag = true;
    },
    showDeleteTag(id) {
      this.deleteTagId = id;
      this.deletingTag = true;
    },
    showEditTag(item) {
      this.editTagId = item.id;
      this.editTagName = item.name;
      this.editingTag = true;
    },
    addTag() {
      let url = `admin/tags/add`
      let data = {
        token: this.token,
        name: this.newTag
      };

      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            this.editTagName = null;
            this.editTagId = null;
            this.editingTag = false;
            this.eventTags = res.data;
            this.$emit('message', {error: false, message: "Event Tag updated successfully"});
          }).catch((error) => {
        this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
      });
    },
    getTags() {
      let url = `admin/tags`
      let data = {
        token: this.token
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            this.eventTags = res.data
          })
          .catch((error) => {
            this.$emit('message', {error: true, message: error.response.data.message})
          })
    },
    editTag() {
      let url = `admin/tags/edit`
      let data = {
        token: this.token,
        id: this.editTagId,
        name: this.editTagName
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            this.eventTags = res.data
            this.editTagName = null;
            this.editTagId = null;
            this.editingTag = false;
            this.$emit('message', {error: false, message: "Event Tag updated successfully"});
          })
          .catch((error) => {
            this.$emit('message', {error: true, message: error.response.data.message})
          })
    },
    deleteTag() {
      let url = `admin/tags/delete`
      let data = {
        token: this.token,
        id: this.deleteTagId,
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            this.eventTags = res.data
            this.deleteTagId = null;
            this.deletingTag = false;
            this.$emit('message', {error: false, message: "Event Tag deleted successfully"});
          })
          .catch((error) => {
            this.$emit('message', {error: true, message: error.response.data.message})
          })
    }
  }
}
</script>
